import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import TagManager from 'react-gtm-module';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { BrowserRouter } from 'react-router-dom';

import { PlayupThemeProvider } from 'playup-web-core';

import appConfig from './appConfig';
import AppLayout from './AppLayout';
import { PortalSessionProvider } from './contexts/PortalSessionContext/PortalSessionContext';
import { GlobalContextProvider } from './contexts/GlobalContext';
import { TutorialContextProvider } from './contexts/TutorialContext';

if (appConfig.googleTagManagerID)
	TagManager.initialize({
		gtmId: appConfig.googleTagManagerID,
		// declare all available events for GTM here:
		events: {
			start_registration: 'start_registration',
			complete_registration: 'complete_registration',
			login: 'login',
			deposit: 'deposit',
			purchase: 'purchase',
			user_details: 'user_details',
		},
	});

// Helmet provider allows us to use Bugsnag in App.tsx instead of Index
if (appConfig.bugsnag.enabled) {
	Bugsnag.start({
		apiKey: appConfig.bugsnag.apiKey as string,
		plugins: [new BugsnagPluginReact()],
		enabledReleaseStages: appConfig.bugsnag.enabledReleaseStages,
		releaseStage: appConfig.bugsnag.releaseStage,
	});
}

// TODO: Error boundry causing issues with typescript-react. Look into alternatives. Bugsnag will still work for time being.
// Bugsnag's error boundry can be null if bugsnag is not enabled, or on first load. Create a passthrough component.
// const FallbackBoundary: React.FC = ({ children }) => <>{children}</>;
// const ErrorBoundary =
// 	(Bugsnag.getPlugin('react')?.createErrorBoundary(React) as BugsnagErrorBoundary) ?? FallbackBoundary;

const App = () => (
	<HelmetProvider>
		<PlayupThemeProvider>
			<BrowserRouter>
				<PortalSessionProvider>
					<GlobalContextProvider>
						<TutorialContextProvider>
							<AppLayout />
						</TutorialContextProvider>
					</GlobalContextProvider>
				</PortalSessionProvider>
			</BrowserRouter>
		</PlayupThemeProvider>
	</HelmetProvider>
);

export default App;
